/**
 * True when the header has a concrete dealership selected (not "All Dealership View" / default).
 * Aligns with Calendar / Emails grid behavior.
 */
export function hasDealerContext(selectedDealer: unknown): boolean {
  if (!selectedDealer || selectedDealer === 'default') return false;
  if (typeof selectedDealer !== 'object') return false;
  const d = selectedDealer as { dealer?: string; _id?: string };
  return Boolean(d.dealer || d._id);
}
